const pathResult = require('../path-result');

/**
 * Add routes to an existing app
 * @param {Object} config - config
 * @param {string} config.assetType - Path segment e.g. 'equities' or 'mmInstruments'
 * @param {Function} config.service - Service as provided by './service-factory'
 * @returns {Function} - A function taking a Muster app and adding routes to it
 */

 function parseJson(obj) {
   return JSON.stringify(obj);
 }

function routeAdderFactory({ assetType, service }) {
  const p = `[{keys:metaData}].portfoliosById`;

  return app =>
    app

      // .match(`${p}.positions[{integers:i}].priceHistory[{integers:j}][{keys:k}]`, requests =>
      //   Promise.all(requests.map(({ req, res }) =>
      //     service.getValueMovement(
      //       req.params.portfolioId,
      //       req.params.i,
      //       req.params.metaData
      //     )
      //       .then(pathResult([req.params.j, req.params.k], res))
      //       .catch(res.error)
      //   ))
      // )

      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{integers:i}].transactions.length`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getTransactions(
            req.params.portfolioId,
            req.params.i,
            req.params.metaData
          )
          // .then(parseJson)
            .then(transactions => res.value(transactions.length))
            .catch(res.error)
        ))
      )

      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{integers:i}].transactions[{integers:j}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getTransactions(
            req.params.portfolioId,
            req.params.i,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.j, req.params.k], res))
            .catch(res.error)
        ))
      )

      .match(`${p}[{keys:portfolioId}].${assetType}.positions.length`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositionsLength(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(length => res.value(length))
            .catch(res.error)
        ))
      )

      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{integers:i}][{keys:k1}][{keys:k2}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositions(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.i, req.params.k1, req.params.k2], res))
            .catch(res.error)
        ))
      )

      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{integers:i}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositions(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.i, req.params.k], res))
            .catch(res.error)
        ))
      )
      
      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{keys:posId}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) => {
          let posId = req.params.posId;
          if (typeof posId === 'string' && posId !== '' && posId !== 'null') {
            posId = parseInt(req.params.posId.slice(3)); // remove 'pos' prefix
          } else {
            posId = null;
          }

          return service.getPositions(
            req.params.portfolioId,
            req.params.metaData,
            posId
          )
            .then(pathResult([0, req.params.k], res))
            .catch(res.error)
        }))
      )
      .match(`${p}[{keys:portfolioId}].${assetType}.positions[{keys:posId}][{keys:k1}][{keys:k2}]`, requests =>
        Promise.all(requests.map(({ req, res }) => {
          let posId = req.params.posId;
          if (typeof posId === 'string' && posId !== '' && posId !== 'null') {
            posId = parseInt(req.params.posId.slice(3)); // remove 'pos' prefix
          } else {
            posId = null;
          }

          return service.getPositions(
            req.params.portfolioId,
            req.params.metaData,
            posId
          )
            .then(pathResult([0, req.params.k1, req.params.k2], res))
            .catch(res.error)
        }))
      )

      // WMCE-4443, BELOW PATHS CREATED TO MATCH PATHS FOR BP IDS AS INTEGERS, BP CONSOLIDATION
      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{integers:i}].transactions.length`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getTransactions(
            req.params.portfolioId,
            req.params.i,
            req.params.metaData
          )
          // .then(parseJson)
            .then(transactions => res.value(transactions.length))
            .catch(res.error)
        ))
      )

      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{integers:i}].transactions[{integers:j}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getTransactions(
            req.params.portfolioId,
            req.params.i,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.j, req.params.k], res))
            .catch(res.error)
        ))
      )

      .match(`${p}[{integers:portfolioId}].${assetType}.positions.length`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositionsLength(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(length => res.value(length))
            .catch(res.error)
        ))
      )

      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{integers:i}][{keys:k1}][{keys:k2}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositions(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.i, req.params.k1, req.params.k2], res))
            .catch(res.error)
        ))
      )

      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{integers:i}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPositions(
            req.params.portfolioId,
            req.params.metaData
          )
          // .then(parseJson)
            .then(pathResult([req.params.i, req.params.k], res))
            .catch(res.error)
        ))
      )
      
      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{keys:posId}][{keys:k}]`, requests =>
        Promise.all(requests.map(({ req, res }) => {
          let posId = req.params.posId;
          if (typeof posId === 'string' && posId !== '' && posId !== 'null') {
            posId = parseInt(req.params.posId.slice(3)); // remove 'pos' prefix
          } else {
            posId = null;
          }

          return service.getPositions(
            req.params.portfolioId,
            req.params.metaData,
            posId
          )
            .then(pathResult([0, req.params.k], res))
            .catch(res.error)
        }))
      )
      .match(`${p}[{integers:portfolioId}].${assetType}.positions[{keys:posId}][{keys:k1}][{keys:k2}]`, requests =>
        Promise.all(requests.map(({ req, res }) => {
          let posId = req.params.posId;
          if (typeof posId === 'string' && posId !== '' && posId !== 'null') {
            posId = parseInt(req.params.posId.slice(3)); // remove 'pos' prefix
          } else {
            posId = null;
          }

          return service.getPositions(
            req.params.portfolioId,
            req.params.metaData,
            posId
          )
            .then(pathResult([0, req.params.k1, req.params.k2], res))
            .catch(res.error)
        }))
      );
}

module.exports = routeAdderFactory;
